// extracted by mini-css-extract-plugin
export default {"selectorMenu":"src-components-LangSelection-module__selectorMenu--67qAz"};